import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    // Ensure loop attribute is set
    videoElement.setAttribute('loop', 'true');
    
    // Explicitly handle looping in case the attribute doesn't work
    videoElement.addEventListener('ended', () => {
      videoElement.currentTime = 0;
      videoElement.play().catch(() => {
        // Autoplay might be prevented, but video will loop when user interacts
      });
    });

    videoElement.load();
    
    // Ensure video plays and loops
    videoElement.play().catch(() => {
      // Autoplay might be prevented, but video will play when user interacts
    });
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
